module.exports = __webpack_public_path__ + "static/media/23-4.57353c70.mp3";